import { useNavigate } from "react-router-dom"

import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command"
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog"

import type { NavGroup } from "@/app/layouts/nav"

interface CommandPaletteProps {
  groups: NavGroup[]
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function CommandPalette({ groups, open, onOpenChange }: CommandPaletteProps) {
  const navigate = useNavigate()
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="top-20 -translate-y-0 p-0">
        <DialogHeader className="sr-only">
          <DialogTitle>Busca global</DialogTitle>
        </DialogHeader>
        <Command loop>
          <CommandInput placeholder="Buscar páginas e ações… (Ctrl+K)" />
          <CommandList>
            <CommandEmpty>Nenhum resultado encontrado.</CommandEmpty>
            {groups.map((group) => (
              <CommandGroup key={group.label} heading={group.label}>
                {group.items.map((item) => (
                  <CommandItem
                    key={item.to}
                    value={`${group.label} ${item.label}`}
                    onSelect={() => {
                      onOpenChange(false)
                      navigate(item.to)
                    }}
                  >
                    <item.icon className="size-4" />
                    {item.label}
                  </CommandItem>
                ))}
              </CommandGroup>
            ))}
          </CommandList>
        </Command>
      </DialogContent>
    </Dialog>
  )
}
